import { render, staticRenderFns } from "./BearbeiteKundenbetreuer.vue?vue&type=template&id=2f20cf88&"
import script from "./BearbeiteKundenbetreuer.vue?vue&type=script&lang=js&"
export * from "./BearbeiteKundenbetreuer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports